module.exports = __webpack_public_path__ + "media/images/vendors/missing_vendors (copy)-e9a3dd088499dd8a5578d6c2d82f1a0b.png";